import React, { FC, useRef } from 'react';
import type { PayallStoryCrossBorderInfrastructureProps } from '@/types';
import { ContentManager } from '../content-manager';
import { useInView } from '@/hooks/reveal-in-view';

export const PayallStoryCrossBorderInfrastructure: FC<
  PayallStoryCrossBorderInfrastructureProps
> = ({ content, worldTitle, worldCoverage }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="payallStoryCrossBorderInfrastructure">
      <div className="wrapper" ref={ref}>
        <ContentManager
          content={content}
          className="payallStoryCrossBorderInfrastructure--content"
          style={{
            transform: isInView ? 'none' : `translateY(20px)`,
            opacity: isInView ? 1 : 0,
            transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
          }}
        />
        <h2
          className="payallStoryCrossBorderInfrastructure--world-title"
          style={{
            transform: isInView ? 'none' : `translateY(20px)`,
            opacity: isInView ? 1 : 0,
            transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
          }}
        >
          {worldTitle}
        </h2>
        <div className="payallStoryCrossBorderInfrastructure--worldCoverage">
          {worldCoverage.map((item, index) => {
            return (
              <div
                key={index}
                className="payallStoryCrossBorderInfrastructure--worldCoverage-item"
                style={{
                  transform: isInView
                    ? 'none'
                    : `translateY(${20 * (index + 1)}px)`,
                  opacity: isInView ? 1 : 0,
                  transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                    index * 0.1 + 0.2
                  }s`,
                }}
              >
                {item.title && (
                  <ContentManager
                    content={item.title}
                    className="payallStoryCrossBorderInfrastructure--worldCoverage-item-title"
                    style={{
                      transform: isInView
                        ? 'none'
                        : `translateY(${20 * (index + 1)}px)`,
                      opacity: isInView ? 1 : 0,
                      transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                        index * 0.1 + 0.4
                      }s`,
                    }}
                  />
                )}
                {item.description && (
                  <ContentManager
                    content={item.description}
                    className="payallStoryCrossBorderInfrastructure--worldCoverage-item-description"
                    style={{
                      transform: isInView
                        ? 'none'
                        : `translateY(${20 * (index + 1)}px)`,
                      opacity: isInView ? 1 : 0,
                      transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                        index * 0.1 + 0.6
                      }s`,
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
